import ApprovalActionsCondition from '@/febos/chile/dnt/mixins/ApprovalActionsCondition';
import ApprovalActionsType from '@/febos/chile/dnt/mixins/ApprovalActionsType';
import RolTypes from '@/febos/chile/dnt/mixins/RolTypes';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';

export const mapApprovalSteps = function mapApprovalSteps({ steps, signaturesDropped, completionFields }) {
  return {
    aprobacionesPlantillaPaso: (steps || []).map((step) => {
      const {
        x,
        y,
        page
      } = signaturesDropped ? signaturesDropped[step.responsibleId] || {} : {};
      let mappedStep = {
        desdePrecio: 0,
        gatillacionesAInsertar: [],
        cantidadMinAprobacion: 1,
        demoraMaxHoras: 0,
        redirigirFlujo: true,
        subrogadoId: '',
        subrogado: '',
        aprobacionesTipoPasoId: step.stepType,
        aprobacionesTipoRolId: step.rolType,
        grupoUsuarios: step.groupUsers || [],
        numeroPaso: step.stepNumber,
        responsable: step.responsibleName,
        responsableCorreo: step.responsibleEmail,
        tipoValorResponsableId: step.stepType === StepTypes.PROVIDER ? null : step.responsibleId,
        ...step.rolType === RolTypes.SIGNER && {
          ...x !== undefined && { x: Math.floor(x) * Math.sign(Math.floor(x)) },
          ...y !== undefined && { y: Math.floor(y) * Math.sign(Math.floor(y)) },
          ...page && { pagina: page }
        },
        ...(step.disregarded && { desatendido: 'Y' })
      };
      if (step.stepType === StepTypes.EXTERNAL) {
        mappedStep = {
          ...mappedStep,
          responsableIut: step.data.responsable.rut,
          responsableTerceroIut: step.data.extra.empresa.iut,
          responsableTerceroNombre: step.data.extra.empresa.razon,
          tipoFirma: step.tipoFirma
        };
      }
      if (step.stepType === StepTypes.PERSON) {
        mappedStep = {
          ...mappedStep,
          responsableIut: step.responsibleIut,
          tipoFirma: step.tipoFirma
        };
      }
      if (Number(step.stepType) === StepTypes.COMPLETION) {
        // Completitud se identifica como Externo (empresa + firmante por RUT),
        // pero con rol REVISOR y SIN firma. Los campos definidos en el builder
        // (nivel de flujo) se serializan en la columna `configuration` del paso
        // como JSON { campos: [...] }.
        mappedStep = {
          ...mappedStep,
          responsableIut: step.data.responsable.rut,
          responsableTerceroIut: step.data.extra.empresa.iut,
          responsableTerceroNombre: step.data.extra.empresa.razon,
          configuration: JSON.stringify({ campos: completionFields || [] })
        };
      }
      return mappedStep;
    })
  };
};
export const mapApprovalActions = function mapApprovalActions({ actions, signaturesDropped }) {
  return {
    acciones: (actions || []).map((actionItem) => {
      const {
        id,
        action,
        when = ApprovalActionsCondition.PRE_FIRST_SIGNER,
        type = ApprovalActionsType.AUTOMATIC
      } = actionItem;
      const {
        x,
        y,
        page
      } = signaturesDropped[`${id}-${action}`] || {};
      return {
        responsable: id,
        accion: action,
        cuando: when,
        tipo: type,
        pagina: page,
        ...x !== undefined && { x: Math.floor(x) * Math.sign(Math.floor(x)) },
        ...y !== undefined && { y: Math.floor(y) * Math.sign(Math.floor(y)) }
      };
    })
  };
};

export default {
  mapApprovalActions,
  mapApprovalSteps
};
